import { render, staticRenderFns } from "./BpDefinitionFormFields.vue?vue&type=template&id=17ae49e0&"
import script from "./BpDefinitionFormFields.vue?vue&type=script&lang=js&"
export * from "./BpDefinitionFormFields.vue?vue&type=script&lang=js&"
import style0 from "./BpDefinitionFormFields.vue?vue&type=style&index=0&id=17ae49e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports